export enum functionPermissions {
  None = 0,
  ListAllCustomers = 1,
  ListCustomerClusters = 2,
  Show3MonthsData = 3,
  Show6MonthsData = 4,
  Show12MonthsData = 5,
  Show24MonthsData = 6,
  AccessCost = 7,
  AccessOrder = 8,
  AccessInventory = 9,
  DownloadArticleList = 10,
  AccessFreights = 11,
  DownloadInvoiceRows = 12,
  AccessDailyStatus = 13,
  MarkDailyStatusAsDone = 14,
  AccessForecast = 15,
  EditSalesForecast = 16,
  EditProductionPlan = 17,
  EditCampaignSetting = 18,
  EditForecastViaFile = 19,
  EditHistoricalValues = 20,
  AccessQuality = 21,
  AccessTrackAndTrace = 22,
  AccessHelpCenter = 23,
  ListAllUsers = 24,
  AddUser = 26,
  EditUser = 27,
  RemoveUser = 28,
  AccessAdminweb = 29,
  AdHocRefreshReportData = 30,
  ScheduleRefreshReportDataFullRecalculation = 31,
  AdHocRefreshReportDataFullRecalculation = 32,
  EditCustomers = 33,
  EditClusters = 34,
  EditCosts = 35,
  EditCurrencies = 36,
  EditWorkingDays = 37,
  EditGlobalSettingsGlobal = 38,
  EditGlobalSettingsCustomerSpecific = 39,
  EditUsers = 40,
  EditRoles = 41,
  EditOrderTypes = 42,
  AdjustOrders = 43,
  DownloadReports = 44,
  EditNotifications = 45,
  EditProcesses = 46,
  CreateNewSimulation = 47,
  CopyCustomerDataIntoSimulatedCustomer = 48,
  EditProducts = 49,
  EditDirections = 50,
  EditProductTypes = 51,
  EditConsumerTypes = 52,
  EditServiceTypes = 53,
  EditRegions = 54,
  EditCountries = 55,
  ReadNonCategorizedProducts = 56,
  ReadFreightCostReports = 57,
  TriggerReImportOfFreightReports = 58,
  MarkAsHandledOnFreightReports = 59,
  ListWorkingDays = 60,
  HealthCheckOrdersPerSku = 61,
  HealthCheckShippedSku = 62,
  HealthCheckForecastAccuracy = 63,
  ShowAllInvoices = 64,
  BotCancelOrder = 65,
  AccessReturnsDockToStock = 66,
  AccessPickingAccuracy = 67,
  AddPickingAccuracyErrors = 68,
  AccessRemainingDailyStatus = 69,
  BotAccess = 70,
  AccessInboundDockToStock = 71,
  BotUpdateOrder = 72,
  BotGetOrder = 73,
  ListClusterGroups = 74,
  AccessProductionSpace = 75,
  EditProductionSpace = 76,
  ApproveAndInvoiceProductionSpace = 77,
  MarkPickingAccuracyErrorCustomerNotified = 78,
  AccessGroupedDailyStatus = 79,
  BotLiveItemBalance = 80,
  BotPageDataAnalysis = 81,
  BotPortalGuide = 82,
}
